import api from './api';

export const searchGlobal = async (query, limit = 10) => {
  const res = await api.get('/search', { params: { q: query, limit } });
  return res;
};